import { useState } from "react";
import { Button } from "@/components/ui/button";
import { CopyIcon, CheckIcon } from "lucide-react";

interface CopyButtonProps {
  value: string;
  label?: string;
  // Renders a labelled button instead of a bare icon.
  text?: string;
}

export default function CopyButton({
  value,
  label = "Copy ID",
  text,
}: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const icon = copied ? (
    <CheckIcon className="h-3 w-3 text-green-500" />
  ) : (
    <CopyIcon className="h-3 w-3" />
  );

  if (text) {
    return (
      <Button
        variant="ghost"
        size="sm"
        className="h-7 gap-1.5 px-2 text-sm"
        onClick={handleCopy}
      >
        {icon}
        {copied ? "Copied" : text}
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-6 w-6 shrink-0"
      onClick={handleCopy}
      aria-label={copied ? "Copied" : label}
    >
      {icon}
    </Button>
  );
}
